import axios from "axios";
import store from "@/store";
import router from "@/router";
import qs from "qs";
import apiUrl from "./config";
import VueCookie from "vue-cookie";
import { Message } from "element-ui";
import $ from "jquery";

async function getLocationIp() {
  if (sessionStorage.getItem("locationData")) {
    const locationData = JSON.parse(sessionStorage.getItem("locationData"));
    if (Date.now() - locationData.updateTime < 7 * 24 * 60 * 60 * 1000) {
      return locationData;
    }
  }

  const keys = [
    "8747ba25423311eea56800163e25360e",
    "de47906d4c5211ee98ee00163e25360e"
  ];
  const defaultData = {
    area_code: "",
    city: "",
    city_code: "",
    continent: "",
    country: "",
    country_code: "",
    district: "",
    elevation: "",
    ip: "127.0.0.1",
    isp: "",
    latitude: "",
    longitude: "",
    province: "",
    street: "",
    time_zone: "",
    weather_station: "",
    zip_code: ""
  };

  try {
    for (let key of keys) {
      const res = await fetch(
        `https://api.ipdatacloud.com/v2/query?key=${key}`,
        {
          method: "GET"
        }
      );

      if (res.ok) {
        const data = await res.json();
        if (data.code === 200) {
          data.data.location.updateTime = Date.now();
          sessionStorage.setItem(
            "locationData",
            JSON.stringify(data.data.location)
          );

          return data.data.location;
        }
      }
    }
    return defaultData;
  } catch (err) {
    return defaultData;
  }
}
getLocationIp().then(res => {
  $.ajaxSetup({
    headers: {
      ip: res.ip,
      fromType: "1",
      appcodeHeader: "PC0000"
    }
  });
});

$.support.cors = true;
let nowUuid;
class ajaxUtil {
  constructor() {
    this.url = "";
    this.type = "";
    this.dataType = "JSON";
    this.data = "";
  }

  post(url, params, option = {}) {
    let baseUrl = option.baseUrl ? option.baseUrl : apiUrl.API_BASE_URL;
    this.url = baseUrl + url;
    this.type = "POST";
    this.data = params ? params : "";
    let defaultOption = {
      url: this.url,
      type: this.type,
      dataType: this.dataType,
      data: this.data
    };
    // 针对home获取banner接口做出的调整
    let cross = option.baseUrl
      ? {
          data: JSON.stringify(this.data),
          contentType: "application/json"
        }
      : {
          xhrFields: { withCredentials: true },
          crossDomain: true
        };

    if (option) {
      defaultOption = $.extend({}, defaultOption, cross, option);
    }
    return $.ajax(defaultOption);
  }

  get(url, params) {
    this.url = apiUrl.API_BASE_URL + url;
    this.type = "GET";
    this.data = params ? params : "";
    let defaultOption = {
      url: this.url,
      type: this.type,
      dataType: this.dataType,
      data: this.data,
      xhrFields: { withCredentials: true },
      crossDomain: true
    };
    if (params.option) {
      defaultOption = $.extend({}, defaultOption, params.option);
    }
    return $.ajax(defaultOption);
  }
}

const _ajax = new ajaxUtil();

$(document).ajaxSend(function(event, jqxhr, settings) {
  if (settings.url !== apiUrl.logUrl) {
    if (!settings.uuid) {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      function guid() {
        return (
          S4() +
          S4() +
          "-" +
          S4() +
          "-" +
          S4() +
          "-" +
          S4() +
          "-" +
          S4() +
          S4() +
          S4()
        );
      }
      nowUuid = guid();
    }
    settings.guid = nowUuid;
    jqxhr.setRequestHeader("uuid", settings.guid);
  }
});

$(document).ajaxSuccess(function(event, request, settings) {
  // let wh = $(window).height()

  // let oh = $('.main-right>.el-card:last')[0].offsetTop
  // let xh = wh - oh
  // console.log(wh, oh);
  let url = settings.url.split("/");
  let reqPath = url.pop();
  let res = request.responseJSON;
  let errmsg = "";
  // typeof res.Data.userBank 防止提现检测是否绑定
  if (
    settings.des &&
    !res.success &&
    !res.IsSuccess &&
    !/未找到关联的/.test(res.Data) &&
    reqPath != "switch" &&
    reqPath != "poundageConfirm" &&
    reqPath != "validate" &&
    reqPath != "isAuthentication" &&
    reqPath.indexOf("advise") < 0 &&
    reqPath != "list" &&
    reqPath != "login" &&
    reqPath != "getPayAggregatedList"
  ) {
    // 普通错误
    errmsg = res.Data;
    // 未登录
    if (res.Status === "-1") {
      errmsg = "未登录，请登录后再试";

      if (
        store.state.userRole == 4 ||
        store.state.userRole == 5 ||
        /www.jf24k/.test(window.location.origin)
      ) {
        let clientid = localStorage.getItem("clientid");
        localStorage.clear();
        localStorage.setItem("clientid", clientid);
        window.location.href = "/login/index.html";
      } else {
        let clientid = localStorage.getItem("clientid");
        localStorage.clear();
        localStorage.setItem("clientid", clientid);
        router.replace("/login/index.html");
      }
    }
    if (errmsg) {
      Message.error({
        message: errmsg
      });
    }
  }
});

$(document).ajaxError(function(event, xhr, options, exc) {
  switch (xhr.status) {
    case 400:
      Message.error({
        message: "错误请求，请联系管理员"
      });
      break;
    case 500:
      // VueCookie.delete('remember')
      Message.error({
        message: "请求失败，请联系管理员"
      });
      break;
  }
});

$(document).ajaxComplete(function(event, xhr, options, exc) {
  if (options.des && !/ibuc/.test(window.location.href)) {
    try {
      function add0(m) {
        return m < 10 ? "0" + m : m;
      }

      function format(shijianchuo) {
        var time = new Date(shijianchuo);
        var y = time.getUTCFullYear();
        var m = time.getUTCMonth() + 1;
        var d = time.getUTCDate();
        var h = time.getUTCHours();
        var mm = time.getUTCMinutes();
        var s = time.getUTCSeconds();
        var fff = time.getUTCMilliseconds();
        return (
          y +
          "-" +
          add0(m) +
          "-" +
          add0(d) +
          " " +
          add0(h) +
          ":" +
          add0(mm) +
          ":" +
          add0(s) +
          "." +
          fff
        );
      }

      var endTime = new Date().getTime();
      if (endTime < options.sTime) {
        endTime = new Date().getTime();
      }
      var params = {
        SourceID: 2,
        AppName: 1,
        FunctionName:
          "PC/" +
          options.url
            .split("?")[0]
            .split("/")
            .pop(),
        FunctionDescription: "[郭鹏]" + options.des,
        Code: options.guid,
        RequestStartTime: format(options.sTime),
        RequestEndTime: format(endTime),
        TotalTimes: +endTime - +options.sTime,
        Remark: "",
        ServerIP: apiUrl.ServerIP,
        Parames: "",
        RequestIP: "",
        Live: 1
      };
      if (xhr.readyState === 4 && xhr.status === 200) {
        params["Result"] = 1;
      } else {
        params["Result"] = 0;
      }

      var res = JSON.parse(xhr.responseText);
      if (
        xhr.readyState === 4 &&
        xhr.status === 200 &&
        !(res.success || res.res || res.Status === "0")
      ) {
        params["Result"] = 2;
      }

      $.ajax({
        url: apiUrl.logUrl,
        type: "post",
        contentType: "application/json",
        beforeSend: function(req) {
          req.setRequestHeader("uuid", params.Code);
        },
        data: JSON.stringify(params)
      });
    } catch (error) {
      console.log(error);
    }
  }
});

/**
 * ========================================================
 * ************    axios     ************
 * ========================================================
 */

// const env = process.envs
// if (env.NODE_ENV != 'development') {
// axios.defaults.baseURL = apiUrl.API_BASE_URL
// axios.defaults.withCredentials = true
// // }

// axios.defaults.transformRequest = function(data) {
//   return qs.stringify(data)
// };

// // http请求拦截器
// axios.interceptors.request.use((config) => {
//   // config.url = config.url+'?'+qs.stringify(config.data)
//   // 在所有请求中添加token头
//   // if (localStorage.getItem('token')) {
//   axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
//   // }
//   return config
// }, (error) => {
//   return error
// })

// // http响应拦截器  根据返回码统一处理msg
// axios.interceptors.response.use((res) => {
//   let errmsg = "";
//   console.log(typeof res.Data.userBank);
//   if (!res.IsSuccess && !/未找到关联的/.test(res.Data)) {
//     // 普通错误
//     errmsg = res.Data
//     // 未登录
//     if (res.Status === '-1') {
//       errmsg = '未登录，请登录后再试'
//       router.replace("/login");
//     }
//     Message.error({
//       message: errmsg
//     });
//   }
//   return res
// }, (error) => {
//   let errmsg = "服务器响应错误";
//   if (error.response) {
//     // 服务器返回错误码
//     switch (error.response.status) {
//       case 401:
//         errmsg = "请登录后操作";
//         router.replace("/login");
//         break;
//       case 404:
//         errmsg = "找不到页面";
//         router.replace("/404");
//         break;
//     }
//   }
//   Message.error({
//     message: errmsg
//   });
//   return error
// })

export default _ajax;



// WEBPACK FOOTER //
// ./src/axios/index.js